import { render, staticRenderFns } from "./WApersonalProvider.vue?vue&type=template&id=e7b5a724&"
import script from "./WApersonalProvider.vue?vue&type=script&lang=js&"
export * from "./WApersonalProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports